module.exports = ".example-radio-group {\n    /* display: flex;\n    flex-direction: row; */\n    margin: 15px 0;\n  }\n  \n  .example-radio-button {\n    margin: 5px;\n  }\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cart-details/cart-details.component.css
// module id = ./src/app/cart-details/cart-details.component.css
// module chunks = main